import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export const Container = styled.div`
  margin-left: 10px;
  width: ${p => p.diameter}px !important;
  height: ${p => p.diameter}px !important;
  border-radius: ${p => p.diameter / 2}px;
  text-align: center;
  background-color: ${p => p.theme.lightBlue};
  color: ${p => p.theme.blue};
`;

function FitlersCount({ count, diameter = 22, style = {} }) {
  if (!count) return null;
  return (
    <Container diameter={diameter} style={style}>
      {count}
    </Container>
  );
}

FitlersCount.propTypes = {
  count: PropTypes.number,
  diameter: PropTypes.number,
  style: PropTypes.shape({}),
};

export default FitlersCount;
